import React from 'react';
import { Mail } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-navy border-t border-gold-dim py-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="/logo_original.jpg" 
                alt="Find Ontario Missing Boys Logo" 
                className="h-12 w-12 rounded-full object-cover"
              />
              <h3 className="text-white font-bold text-lg">Find Ontario Missing Boys</h3>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              A province-wide, community-led advocacy initiative supporting Black youth and families 
              impacted by disappearance, exploitation, trafficking risk, and system involvement across Ontario.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-gray-400 hover:text-gold text-sm transition-colors">
                  Home
                </a>
              </li>
              <li>
                <a href="/share" className="text-gray-400 hover:text-gold text-sm transition-colors">
                  Share Your Experience
                </a>
              </li>
              <li>
                <a href="/about" className="text-gray-400 hover:text-gold text-sm transition-colors">
                  About
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Contact</h3>
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <Mail size={16} />
              <a href="mailto:findontariomissingboys@gmail.com" className="hover:text-gold transition-colors">
                findontariomissingboys@gmail.com
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Find Ontario Missing Boys. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs mt-2">
            This is not an emergency service. If someone is missing right now, call 911.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
